// Every schedule activity an issue is on, first one first (owner, 2026-10-16:
// an issue can sit on several activities and counts in full on each - the
// server's utils/issueActivities). ganttItemId is the first, alsoGanttItemIds
// the rest; both may be ids or populated rows.
const idOf = (v) => String((v && v._id) || v || "");

export function issueActivityIds(issue) {
  const out = [];
  const add = (v) => { const s = idOf(v); if (s && !out.includes(s)) out.push(s); };
  if (!issue) return out;
  add(issue.ganttItemId);
  (issue.alsoGanttItemIds || []).forEach(add);
  return out;
}

/** True when the issue is on the activity `gid` (first or one of several). */
export function issueOnActivity(issue, gid) {
  return issueActivityIds(issue).includes(String(gid));
}
